var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gb_svg__clip0_1243_4642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .5h21v21H0V.5z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 .5v2.625L13.207 11 21 18.67v2.83h-2.748l-7.834-7.71-7.629 7.71H0v-2.79l7.629-7.669L0 3.535V.5h2.543l7.875 7.71L18.047.5H21z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.547 13.79l.451 1.394L1.723 21.5H0v-.123l7.547-7.588zm5.086-.493l2.215.328L21 19.655V21.5l-8.367-8.203zM21 .5l-7.875 8.04-.164-1.806L19.113.5H21zM0 .541l7.916 7.752-2.42-.328L0 2.51V.54z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.219.5v21h6.562V.5H7.22zM0 7.719v6.562h21V7.72H0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.031v3.938h21V9.03H0zM8.531.5v21h3.938V.5H8.53z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gb_svg__clip0_1243_4642"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#fff"
  })))));
}
export default SvgGb;